export default __webpack_public_path__ + "static/carousel6-79cb8188a798ee654facae03ab3240ca.webp";